// extracted by mini-css-extract-plugin
export default {"container":"error_container__CTktH","heading":"error_heading__LHHkr","heading3":"error_heading3__EKzUt","text":"error_text__KH0uC","link":"error_link__vKw2l"};